import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus, Sparkles } from 'lucide-react';
import { Button } from '@ideoz/ui';
import { WorkScopesModule } from '../modules/workScopes';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupWorkScopesPage(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // The header buttons only toggle open-state; the dialogs themselves live in
  // WorkScopesModule so they share its facade + ICE (new cards show "Scoring…"
  // without any cross-component wiring).
  const [createOpen, setCreateOpen] = useState(false);
  const [suggestOpen, setSuggestOpen] = useState(false);

  return (
    <StartupSubPageShell
      activeSection="work-scopes"
      // This page owns its create action (shared with the list's facade), so
      // suppress the shell's built-in "New Scope" button.
      showNewScopeAction={false}
      headerActions={
        <>
          <Button
            variant="outline"
            size="xs"
            onClick={() => setSuggestOpen(true)}
            className="gap-1.5 border-primary-200 text-primary-700 hover:bg-primary-50 dark:border-primary-500/40 dark:text-primary-300 dark:hover:bg-primary-500/10"
            data-testid="suggest-scopes-button"
          >
            <Sparkles size={14} />
            {t('workScopes.addMultiple')}
          </Button>
          <Button
            variant="primary"
            size="xs"
            onClick={() => setCreateOpen(true)}
            className="gap-1.5"
            data-testid="new-scope-button"
          >
            <Plus size={14} />
            {t('workScopes.newScope')}
          </Button>
        </>
      }
    >
      {({ startup, startupId }) => (
        <WorkScopesModule
          startupId={startupId}
          onNavigateToScope={(id) => navigate(`/${startup.slug}/${id}`)}
          createOpen={createOpen}
          onCreateClose={() => setCreateOpen(false)}
          onOpenCreate={() => setCreateOpen(true)}
          suggestOpen={suggestOpen}
          onSuggestClose={() => setSuggestOpen(false)}
          onOpenSuggest={() => setSuggestOpen(true)}
        />
      )}
    </StartupSubPageShell>
  );
}
